var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-card",
    { staticClass: "forget-content" },
    [
      _c("FormClose", { on: { "on-close": () => _vm.$emit("on-close") } }),
      _c("div", { staticClass: "reg-page" }, [
        _c("div", { staticClass: "title" }, [_vm._v("欢迎注册Metacare")]),
        _c("div", { staticClass: "steps-content" }, [
          _c(
            "div",
            [
              _c(
                "a-form-model",
                {
                  ref: "ruleForm",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-col": _vm.labelCol,
                    "wrapper-col": _vm.wrapperCol,
                  },
                },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { prop: "mobile" } },
                    [
                      _c(
                        "a-input",
                        {
                          attrs: {
                            placeholder: "请输入手机号",
                            allowClear: "",
                          },
                          model: {
                            value: _vm.form.mobile,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "mobile", $$v)
                            },
                            expression: "form.mobile",
                          },
                        },
                        [
                          _c("a-icon", {
                            style: { color: "rgba(0,0,0,.25)" },
                            attrs: { slot: "prefix", type: "mobile" },
                            slot: "prefix",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    { attrs: { prop: "code" } },
                    [
                      _c(
                        "a-input",
                        {
                          attrs: {
                            placeholder: "请输入验证码",
                            allowClear: "",
                          },
                          model: {
                            value: _vm.form.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "code", $$v)
                            },
                            expression: "form.code",
                          },
                        },
                        [
                          _c("a-icon", {
                            style: { color: "rgba(0,0,0,.25)" },
                            attrs: { slot: "prefix", type: "mail" },
                            slot: "prefix",
                          }),
                          _c("a-button", {
                            staticClass: "getCaptcha",
                            attrs: {
                              slot: "suffix",
                              tabindex: "-1",
                              disabled: _vm.state.smsSendBtn,
                            },
                            domProps: {
                              textContent: _vm._s(
                                (!_vm.state.smsSendBtn && "获取验证码") ||
                                  _vm.state.time + " s"
                              ),
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.getCaptcha.apply(null, arguments)
                              },
                            },
                            slot: "suffix",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    { attrs: { prop: "passwd" } },
                    [
                      _c(
                        "a-input-password",
                        {
                          attrs: { placeholder: "请输入密码" },
                          model: {
                            value: _vm.form.passwd,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "passwd", $$v)
                            },
                            expression: "form.passwd",
                          },
                        },
                        [
                          _c("a-icon", {
                            style: { color: "rgba(0,0,0,.25)" },
                            attrs: { slot: "prefix", type: "lock" },
                            slot: "prefix",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("a-form-model-item", [
                    _c(
                      "div",
                      { staticStyle: { position: "relative" } },
                      [_vm._t("privacy")],
                      2
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "center",
                          margin: "168px 0 0 0",
                        },
                      },
                      [
                        _c(
                          "a-button",
                          {
                            staticClass: "login-button",
                            attrs: {
                              size: "large",
                              type: "primary",
                              loading: _vm.state.loginBtn,
                              disabled: _vm.state.loginBtn,
                            },
                            on: { click: _vm.onSubmit },
                          },
                          [_vm._v(" 下一步 ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "user-login-other" }, [
            _c("span", [_vm._v("已有账号? ")]),
            _c(
              "a",
              { staticStyle: { color: "#3570f5" }, on: { click: _vm.toLogin } },
              [_vm._v("立即登录")]
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }